import React from 'react';
import { Link } from 'react-router-dom';

const Cancel: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 py-20 bg-gray-50">
      <div className="w-full max-w-[600px] bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="flex flex-col items-center pt-16 pb-10 px-6 text-center">
          <div className="size-20 rounded-full bg-red-100 flex items-center justify-center mb-8">
            <span className="material-symbols-outlined text-5xl text-red-600 font-bold">cancel</span>
          </div>
          <h1 className="text-4xl font-black tracking-tighter uppercase mb-4 italic">Pago Cancelado</h1>
          <p className="text-gray-500 text-lg max-w-sm">
            No hemos procesado ningún cargo. Puedes volver e intentarlo de nuevo cuando estés listo.
          </p>
        </div>

        <div className="px-10 mb-10">
          <div className="w-full h-56 rounded-2xl overflow-hidden shadow-inner">
            <img 
              src="\logo_full.png" 
              className="w-full h-full object-cover grayscale opacity-90 transition-all hover:grayscale-0 duration-700" 
              alt="Coche en espera" 
            />
          </div>
        </div>

        <div className="px-10 pb-16 flex flex-col gap-4">
          <Link to="/checkout" className="w-full bg-primary hover:bg-blue-700 text-white font-bold h-16 rounded-xl transition-all flex items-center justify-center gap-2 group uppercase tracking-widest italic">
            Volver al Carrito
            <span className="material-symbols-outlined transition-transform group-hover:translate-x-1">refresh</span>
          </Link>
          <Link to="/" className="text-gray-400 text-sm font-bold uppercase tracking-widest text-center hover:text-black transition-colors">
            Volver al Inicio
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cancel;